import { DossierId } from '../dossier/types';

import {
    GetPreTripReviewsRequestAction,
    NormalizedPreTripReview,
    GetPreTripReviewsSuccessAction,
    GetPreTripReviewsFailureAction,
    RemovePreTripReviewAction,
    RemovePreTripReviewFailureAction,
    RemovePreTripReviewSuccessAction,
} from './types';

export const fetchPreTripReviewsRequestAction = 'preTripReview/FETCH_ALL_REQUEST';
export const fetchPreTripReviewsSuccessAction = 'preTripReview/FETCH_ALL_SUCCESS';
export const fetchPreTripReviewsFailureAction = 'preTripReview/FETCH_ALL_FAILURE';
export const removePreTripReviewAction = 'preTripReview/REMOVE_REQUEST';
export const removePreTripReviewSuccessAction = 'preTripReview/REMOVE_SUCCESS';
export const removePreTripReviewFailureAction = 'preTripReview/REMOVE_FAILURE';

export const getPreTripReviewsRequest = (): GetPreTripReviewsRequestAction => {
    return {
        type: fetchPreTripReviewsRequestAction,
    };
};

export const getPreTripReviewsSuccess = (
    response: NormalizedPreTripReview,
): GetPreTripReviewsSuccessAction => ({
    type: fetchPreTripReviewsSuccessAction,
    response,
});

export const getPreTripReviewsFailure = (error: string): GetPreTripReviewsFailureAction => ({
    type: fetchPreTripReviewsFailureAction,
    error,
});

export const removePreTripReview = (dossierId: DossierId): RemovePreTripReviewAction => ({
    type: removePreTripReviewAction,
    dossierId,
});

export const removePreTripReviewSuccess = (): RemovePreTripReviewSuccessAction => ({
    type: removePreTripReviewSuccessAction,
});

export const removePreTripReviewFailure = (error: string): RemovePreTripReviewFailureAction => ({
    type: removePreTripReviewFailureAction,
    error,
});
